import { TextField } from '@mui/material';
import { ContactFields } from '../../components/ContactFields';
import { FormDialog } from '../../components/FormDialog';
import { ServiceCheckboxes } from '../../components/ServiceCheckboxes';
import { slug } from '../../lib/text';
import { addedText } from '../claudeTasks/useVaultRecords';
import { useAddForm } from '../../lib/useAddForm';
import type { Service } from '../../lib/services';
import type { Agent } from './sample';

const blank = {
  name: '',
  country: '',
  city: '',
  contact: '',
  phone: '',
  email: '',
  coverage: '',
  notes: '',
  services: [] as Service[],
};

/** A form for a new overseas agent. It goes to Claude, who writes it into the vault. */
export function AddAgentDialog({
  open,
  onClose,
  onAdd,
}: {
  open: boolean;
  onClose: () => void;
  onAdd: (a: Agent) => void | Promise<unknown>;
}) {
  const { form, set, save, busy } = useAddForm(
    blank,
    (f): Agent => ({
      ...f,
      id: slug(f.name),
      address: '',
      website: '',
      industry: 'Freight Forwarding',
      status: 'Active',
      addedDaysAgo: 0,
    }),
    onAdd,
    onClose,
    addedText('Agent'),
  );
  return (
    <FormDialog
      open={open}
      onClose={onClose}
      title="Add an agent"
      saveLabel="Add agent"
      canSave={Boolean(form.name.trim()) && !busy}
      onSave={save}
    >
      <ContactFields value={form} onChange={set} />
      <ServiceCheckboxes value={form.services} onChange={(services) => set({ services })} />
      <TextField
        label="Coverage"
        placeholder="e.g. Europe, Far East"
        value={form.coverage}
        onChange={(e) => set({ coverage: e.target.value })}
      />
      <TextField label="Notes (optional)" value={form.notes} onChange={(e) => set({ notes: e.target.value })} />
    </FormDialog>
  );
}
